import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';

// Scope statuses matching backend schema (services/project-tracker/backend/schemas/organizations.py:125-132)
export type ScopeStatus =
  | 'not_started'
  | 'in_progress'
  | 'waiting_on_them'
  | 'waiting_on_us'
  | 'complete'
  | 'on_hold';

interface ScopeStatusOption {
  value: ScopeStatus;
  label: string;
}

const scopeStatuses: ScopeStatusOption[] = [
  { value: 'not_started', label: 'Not Started' },
  { value: 'in_progress', label: 'In Progress' },
  { value: 'waiting_on_them', label: 'Waiting on Them' },
  { value: 'waiting_on_us', label: 'Waiting on Us' },
  { value: 'complete', label: 'Complete' },
  { value: 'on_hold', label: 'On Hold' },
];

interface ScopeStatusDropdownProps {
  value: ScopeStatus | undefined;
  onChange: (value: ScopeStatus) => void;
  disabled?: boolean;
  className?: string;
  id?: string;
}

/**
 * Dropdown for selecting scope status (action owner / ball in court tracking).
 *
 * Key statuses:
 * - "Waiting on Us" - Action required from our team
 * - "Waiting on Them" - Action required from external party
 * - Other statuses track typical workflow progression
 */
export function ScopeStatusDropdown({
  value,
  onChange,
  disabled = false,
  className,
  id,
}: ScopeStatusDropdownProps) {
  return (
    <Select
      value={value}
      onValueChange={onChange}
      disabled={disabled}
    >
      <SelectTrigger className={className} id={id}>
        <SelectValue placeholder="Select status" />
      </SelectTrigger>
      <SelectContent>
        {scopeStatuses.map((status) => (
          <SelectItem key={status.value} value={status.value}>
            {status.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
